import format from '@/lib/format.js'
export default {
  formatterDate(date, index){
    let gmt = date.split('GMT')[1]
    let time = format.convertTimeZone(new Date(date), gmt);
    var utcTime = new Date(time.getTime() + index*86400000).getTime()/1000;
    return format.formatterDateHCL(utcTime)
  },
  addProps(object, addProp){
    // 如果属性不存在则添加，如果存在则相加
    for([key, value] of Object.entries(addProp)){
      if(!object[key]){
        object[key] = value
      }else{
        object[key] = this.addNumFixed(value, object[key])
      }
    }
  },
  addNumFixed(num1, num2){
    return Math.round(num1*100 + num2*100)/100
  },
  invalidAccountMSG(invalidAccount, ctx){
    if(invalidAccount.length){
      const h = ctx.$createElement
      ctx.$msgbox({
        confirmButtonText: '确定',
        message: h('div', [
          h('span','提示: 导入设置中存在无效账号，无效账号将不会显示结果!') , 
          h('div', {
            style: {
              border:"1px solid black",
              margin:"30px 0 0 10%",
              width:"80%",
              height:"100px",
              overflow:"auto",
            }}, invalidAccount.map(item=>{
              return h('p', item.accountName)
            }))
          ])
      })
    }
  },
}


// WEBPACK FOOTER //
// ./src/components/AccountAdmin/dataSTS/publicMethod.js